type THydrationState = "undefined" | "started" | "finished";

interface IStorageState {
  hasHydrated: THydrationState;
}

export const storageStoreDefaults: IStorageState = {
  hasHydrated: "undefined",
};

interface IStorageAction {
  setHasHydrated: (state: THydrationState) => void;
}

export interface IStorageStore extends IStorageState, IStorageAction {}
